export default function (time: number) {
    const date = new Date(time)
    const hours = date.getHours()
    const minutes = date.getMinutes()
    const timeFormat = hours > 11 ? 'PM' : 'AM'
    const formattedHours = hours === 12 ? hours : hours % 12
    return `${formattedHours > 9 ? formattedHours : '0' + formattedHours}:${minutes > 9 ? minutes : '0' + minutes} ${timeFormat}`
}